var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmojiVermelho(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3551_43912)",
    filter: "url(#filter0_ii_3551_43912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 15C30 23.2833 23.286 30 14.9983 30C6.71057 30 0 23.2833 0 15C0 6.71673 6.7175 0 15.0017 0C23.286 0 30.0035 6.71673 30.0035 15H30Z",
    fill: "url(#paint0_linear_3551_43912)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3551_43912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 6.62928C30 7.94033 28.8794 9 27.502 9C26.1247 9 25 7.93646 25 6.62928C25 5.62762 26.4588 3.24917 27.1475 2.18564C27.3064 1.93812 27.6854 1.93812 27.8484 2.18564C28.5371 3.24917 29.9959 5.62376 29.9959 6.62928H30Z",
    fill: "#61C0EB"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.85453 9.9642C5.71588 9.9642 5.5807 9.90528 5.48365 9.79437C5.30687 9.58989 5.33113 9.28143 5.53564 9.10468C6.51311 8.26595 7.76094 7.73915 9.04344 7.62478C9.31727 7.59705 9.5495 7.79807 9.57377 8.0684C9.59803 8.33874 9.40046 8.57441 9.13009 8.59867C8.04517 8.69571 6.99491 9.13934 6.16995 9.84636C6.07637 9.92607 5.96545 9.9642 5.85106 9.9642H5.85453Z",
    fill: "#562912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9757 9.9642C23.8613 9.9642 23.7504 9.92607 23.6568 9.84636C22.8318 9.13934 21.7816 8.69571 20.6967 8.59867C20.4263 8.57441 20.2287 8.33527 20.253 8.0684C20.2773 7.79807 20.5095 7.59705 20.7833 7.62478C22.0693 7.73915 23.3136 8.26595 24.2946 9.10468C24.4991 9.28143 24.5234 9.58989 24.3466 9.79437C24.2495 9.90875 24.1143 9.9642 23.9757 9.9642Z",
    fill: "#562912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2113 15.3986C10.2113 16.6047 9.52156 17.5855 8.66888 17.5855C7.81619 17.5855 7.12988 16.6081 7.12988 15.3986C7.12988 14.189 7.81966 13.2116 8.66888 13.2116C9.5181 13.2116 10.2113 14.1925 10.2113 15.3986Z",
    fill: "#562912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7035 15.3986C22.7035 16.6047 22.0138 17.5855 21.1645 17.5855C20.3153 17.5855 19.6221 16.6081 19.6221 15.3986C19.6221 14.189 20.3118 13.2116 21.1645 13.2116C22.0172 13.2116 22.7035 14.1925 22.7035 15.3986Z",
    fill: "#562912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4038 23.6818C19.792 23.7616 20.0624 23.1793 19.8024 22.8015C18.6655 21.1275 16.9012 20.0497 14.9185 20.0497C12.9359 20.0497 11.1716 21.1275 10.0312 22.8015C9.77123 23.1828 10.0416 23.7616 10.4298 23.6818C11.7782 23.4046 13.2998 23.2521 14.9151 23.2521C16.5303 23.2521 18.0555 23.408 19.4038 23.6818Z",
    fill: "#562912"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_3551_43912",
    x: -2,
    y: -2,
    width: 35,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.42 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3551_43912"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.616667 0 0 0 0 0.434655 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3551_43912",
    result: "effect2_innerShadow_3551_43912"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3551_43912",
    x1: 15.0017,
    y1: -3.20933,
    x2: 15.0017,
    y2: 27.3279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658654,
    stopColor: "#FFCE00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3551_43912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3551_43912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 7,
    fill: "white",
    transform: "translate(25 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiVermelho);
export default __webpack_public_path__ + "static/media/emoji_vermelho.e488b9cccb7ec078e1e49140886c6018.svg";
export { ForwardRef as ReactComponent };